import { mapState } from 'vuex';
export default {
  name: 'NiotaClassicDevicesDeviceDetailsStatistics',
  props: {
    deviceData: {
      type: Object,
      required: false,
      default: null
    },
    periodStatistics: {
      type: Object,
      required: false,
      default: null
    },
    periodOlderStatistics: {
      type: Object,
      required: false,
      default: null
    },
    packetsIncreaseRatio: {
      type: Object,
      required: false,
      default: null
    },
    sendingRate: {
      type: Number,
      required: false,
      default: 0
    },
    validStatistics: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      showDeviceStatistics: false,
      newPacketsbyWS: 0,
      selectedTimeFrame: {
        length: 1,
        name: this.$i18n_t('NiotaClassic.Devices.details.last24')
      },
      timeFrames: [{
        length: 1,
        name: this.$i18n_t('NiotaClassic.Devices.details.last24')
      }, {
        length: 7,
        name: this.$i18n_t('NiotaClassic.Devices.details.lastWeek')
      }, {
        length: 31,
        name: this.$i18n_t('NiotaClassic.Devices.details.lastMonth')
      }]
    };
  },
  computed: {
    ...mapState('app', ['color'])
  }
};